import React, { useState, useEffect } from 'react';
import clsx from 'clsx';
import Icon from './Icon';
import styles from '../../styles/components/atoms/Sorter.module.scss';

interface SorterProps {
  onClick: (order: string | null) => void;
  className?: string;
  active?: boolean;
  data: { key?: string; label: string; order: string };
}

const ORDER_STATES = ['asc', 'desc'];

export default function Sorter(props: SorterProps) {
  const { onClick, data, active, className } = props;
  const { sorter } = styles;
  const [order, setOrder] = useState<string>('desc');
  const classes = clsx(
    sorter,
    order ? styles[order] : undefined,
    { [styles.active]: active },
    className
  );
  const toggle = () => {
    if (active) {
      const orderIndex = ORDER_STATES.indexOf(order);
      const newOrder = ORDER_STATES.at(
        (orderIndex + 1) % ORDER_STATES.length
      ) as string;
      setOrder(newOrder);
      onClick(newOrder);
    } else {
      onClick(order);
    }
  };

  useEffect(() => {
    setOrder(data.order || 'desc');
  }, [data]);

  return (
    <button className={classes} onClick={toggle}>
      {!!data.label && (
        <small>{active ? <b>{data.label}</b> : data.label}</small>
      )}
      <Icon name="sort" />
    </button>
  );
}
